import { sortBy } from 'components/data/helpers';

const sortByName = sortBy('name');
const sortByIndex = sortBy('sortIndex');

export function getInitAttributeOrder(definitions = []) {
  // If no sortIndex sort by name, otherwise use sortIndex;
  return [...definitions].sort(
    typeof definitions[0]?.sortIndex === 'number' ? sortByIndex : sortByName
  );
}

export const toNumber = (value) => {
  if (value == null) {
    return undefined;
  }

  if (typeof value === 'string' && value.trim() === '') {
    return undefined;
  }

  try {
    const numericValue = Number(value);

    return Number.isFinite(numericValue) ? numericValue : undefined;
  } catch {
    return undefined;
  }
};
